import React, { useContext } from 'react'
import { Card, FlexView } from 'components/common'
import styled from 'styled-components'

import JobSummaryInfoCard from 'app-components/run-in-hole/job-summary/JobSummaryInfoCard'
import JobSummaryIndicator from 'app-components/run-in-hole/job-summary/JobSummaryIndicator'

import DonutChartCard from 'app-components/general/DonutChartCard'

import { useTranslation } from 'react-i18next'

import { JobContext } from 'stores/JobStore'

const Subtitle = styled.h3`
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 20px;
    text-align: justify;
    color: #777777;
    margin: 16px 0;
`
const ChartCard = styled(Card)`
    border: 2px solid #E0E0E0;
    box-sizing: border-box;
    border-radius: 8px;
    margin-bottom: 18px;

    & .infoCardTitle {
      align-self: flex-start;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 18px;

      text-align: justify;
      color: #303030;
      margin: 5px 5px;  
    }
`

const JobSummary = () => {
  const {
    highlightData,
    performanceIndicators,
    pipesSummary,
    accessoriesSummary,
    pipeListDonutChartData,
  } = useContext(JobContext)

  const { t } = useTranslation()

  return (
    <Card>
      <Subtitle>{t('Job Summary')}</Subtitle>
      <FlexView alignItems="center" flexDirection="row" heigth="100%">
        <ChartCard>
          <DonutChartCard ChartData={pipeListDonutChartData} />
        </ChartCard>
        <FlexView flexDirection="column" style={{ alignSelf: 'center', marginTop: '5px' }}>
          <JobSummaryInfoCard jobInfoData={pipesSummary} title="Pipes" />
          <JobSummaryInfoCard jobInfoData={accessoriesSummary} title="Accessories" />
        </FlexView>
      </FlexView>

      <Subtitle>{t('Performance Indicators')}</Subtitle>
      <JobSummaryIndicator indicatorData={performanceIndicators} highlightData={highlightData} />
    </Card >
  )

}

export default JobSummary